import { createFileRoute, useNavigate } from "@tanstack/react-router";
import Teilzahlungsrechner, {
  defaultTeilzahlungSearch,
  type TeilzahlungSearch,
} from "@/pages/Teilzahlungsrechner";

const TITLE = "Teilzahlungsrechner 2026 – Kreditkarten-Zinsen berechnen";
const DESCRIPTION =
  "Kostenloser Teilzahlungsrechner: Laufzeit und Zinskosten eines Kreditkarten-Saldos berechnen — und sehen, wie viel die Vollzahlung spart.";
const URL = "https://www.kreditkarten.de/tools/teilzahlungsrechner";

const str = (value: unknown) => (typeof value === "string" ? value : "");

export const Route = createFileRoute("/tools/teilzahlungsrechner")({
  validateSearch: (search: Record<string, unknown>): TeilzahlungSearch => ({
    betrag: str(search.betrag) || defaultTeilzahlungSearch.betrag,
    rate: str(search.rate) || defaultTeilzahlungSearch.rate,
    zins: str(search.zins),
  }),
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { property: "og:url", content: URL },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
  component: TeilzahlungRoute,
});

function TeilzahlungRoute() {
  const values = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  const setValue = (key: keyof TeilzahlungSearch, value: string) => {
    navigate({
      search: (prev: TeilzahlungSearch) => ({ ...prev, [key]: value }),
      replace: true,
    });
  };

  return <Teilzahlungsrechner values={values} onChange={setValue} />;
}
